import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow } from "vue"
import _imports_0 from '../assets/images/boxClose.gif'


const _hoisted_1 = {
  class: "layer deletAlt",
  style: {"width":"300px"}
}
const _hoisted_2 = { class: "layerTitle" }
const _hoisted_3 = {
  key: 0,
  class: "layerMain"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "red bold" }, "인증번호를 문자 메시지", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "통신환경에 따라 인증번호를 받는데 시간이 걸릴 수 있습니다. ", -1)
const _hoisted_8 = {
  key: 1,
  class: "layerMain"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "red bold" }, "로그인 인증 푸시 메시지", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "red bold" }, "스마트폰에서 확인"),
  /*#__PURE__*/_createTextVNode(" 버튼을 누른 후"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "red bold" }, "인증완료"),
  /*#__PURE__*/_createTextVNode(" 버튼을 눌러주세요. ")
], -1)
const _hoisted_12 = {
  key: 2,
  class: "textCenter"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode("알림 "),
      _createElementVNode("img", {
        class: "right",
        src: _imports_0,
        style: {"cursor":"pointer","width":"20px"},
        alt: "close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.hide && $options.hide(...args)))
      })
    ]),
    (!$data.pushMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("p", null, [
            _createTextVNode(" ‘" + _toDisplayString($options.user.ACNT_NM) + "’ 님의 스마트폰으로 ", 1),
            _hoisted_4,
            _createTextVNode(" 로그인 "),
            _hoisted_5,
            _createTextVNode("로 "),
            _hoisted_6,
            _createTextVNode(" 전송하였습니다. ")
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            style: {"width":"150px"},
            placeholder: "인증번호를 입력하세요",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.certTxt) = $event)),
            onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => ($options.cert && $options.cert(...args)), ["enter"]))
          }, null, 544), [
            [_vModelText, $data.certTxt]
          ]),
          _createTextVNode(),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($options.cert && $options.cert(...args)))
          }, _toDisplayString(`${$data.expTime ? '인증번호 확인' : '인증번호 재발송'}`), 1),
          _createElementVNode("p", {
            class: _normalizeClass(["bold", [$data.expTime > 0 ? 'blue' : 'red']])
          }, "입력가능시간" + _toDisplayString($options.expTimeStr), 3),
          _hoisted_7
        ]))
      : _createCommentVNode("", true),
    ($data.pushMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", null, [
            _createTextVNode(" ‘" + _toDisplayString($options.user.ACNT_NM) + "’ 님의 스마트폰으로 ", 1),
            _hoisted_9,
            _hoisted_10,
            _createTextVNode("를 전송하였습니다. ")
          ]),
          _hoisted_11,
          _createElementVNode("p", null, [
            _createElementVNode("u", {
              class: "blue",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($options.useSmsCert(_ctx.e))),
              style: {"cursor":"pointer"}
            }, "문자 인증번호로 로그인")
          ])
        ]))
      : _createCommentVNode("", true),
    ($data.pushMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("button", {
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($options.send && $options.send(...args)))
          }, "푸시 재발송"),
          _createElementVNode("button", {
            class: "mgL15",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($options.cert && $options.cert(...args)))
          }, "인증완료")
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, $data.visible]
  ])
}